// extracted by mini-css-extract-plugin
export default {"strip":"SY6_fS","root":"p504hU","title":"lVXSMa","listOfBenefits":"B6yc_I","benefit":"mFWIQd","benefitTextBox":"gM_mJV","benefitTitle":"B0BL7n","benefitDescription":"_Q4SLL"};